import { type BuilderCoreState } from '@/lib/builder/types'
import { OlympusClient } from '@/OlympusClient'

import {
  type WebsiteResource,
  type WebsiteSection,
} from '../WebsiteBuilder.types'

export const publishStyleChanges = async (
  update: BuilderCoreState<WebsiteResource, WebsiteSection>
): Promise<BuilderCoreState<WebsiteResource, WebsiteSection>> => {
  const promises = []

  if (update.resource?.brand) {
    promises.push(
      OlympusClient.brandsV0.brand.updateBrand({
        body: {
          assets: {
            ...update.resource.brand.assets,
            logo: update.resource.brand.assets.logo,
          },
        },
        params: {
          brandId: update.resource.brand.id,
        },
      })
    )
  }

  if (update.resource?.theme) {
    promises.push(
      OlympusClient.brandsV0.brand.theme.overrides.updateBrightnessPalette({
        body: { palette: update.resource.theme.palette },
        params: {
          brandId: update.resource.theme.brandId,
        },
      })
    )

    promises.push(
      OlympusClient.brandsV0.brand.theme.overrides.updateOverrides({
        body: update.resource.theme.overrides ?? {},
        params: {
          brandId: update.resource.theme.brandId,
        },
      })
    )
  }

  await Promise.all(promises)

  return update
}
